import { cn } from '@/lib/utils'

interface PageContainerProps {
  className?: string
  children: React.ReactNode
}

export default function PageContainer({
  children,
  className,
}: PageContainerProps) {
  return (
    <section
      className={cn(
        'bg-[#F5F5F5] md:bg-white rounded-[.75rem] container-shadow p-5',
        className
      )}
    >
      {children}
    </section>
  )
}
